import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { CountryConfigNames } from '../../contexts/country-config-context/country-config-enums';
import { useCountryConfig } from '../../hooks/use-country-config';
import { RateBrowserProviderPropType } from '../../prop-types/rate-browser-provider';
import { RateBrowserRatePropType } from '../../prop-types/rate-browser-rate';
import { RateBrowserSelectedProviderPropType } from '../../prop-types/rate-browser-selected-provider';
import { EventSourceStrings } from '../../tracking/tracking-constants';
import { WalletRegistrationOrUpdateButton } from '../../wallet/components/wallet-registration-or-update-button';
import { useWallet } from '../../wallet/hooks/use-wallet';
import RateList from './rate-list';

import { messages } from './messages';
import style from './rate-viewer.module.less';

const MainContent = ({ isLoading, sellerProviderRates, validationErrors, selectedRate, selectedProvider, onRateSelected }) => {
  const { isWalletRegistered } = useWallet();
  const [requiresWalletForRateBrowser] = useCountryConfig(CountryConfigNames.RequiresWalletForRateBrowser);
  const showWalletRequiredMessage = requiresWalletForRateBrowser && !isWalletRegistered;

  if (isLoading) {
    return <LoadingIndicator className={style['loading-indicator']} data-testid='loading-indicator' />;
  }

  if (sellerProviderRates.length === 0) {
    return (
      <div className={style['empty-content']}>
        {validationErrors
          ? validationErrors.map((error) => (
              <div key={error} className={style['error-message']}>
                <BannerMessageV2 content={error} status={BannerStatus.Error} />
              </div>
            ))
          : null}
        <div className={style['empty-message']}>
          {showWalletRequiredMessage ? (
            <>
              <Text textType={TextType.H4} value={messages.walletRequiredMessage} />
              <WalletRegistrationOrUpdateButton trackingId={EventSourceStrings.RATE_BROWSER_EMPTY_STATE}>
                {({ openModal }) => (
                  <Button className={style['wallet-activation-button']} onClick={openModal} theme='primary'>
                    <FormattedMessage {...messages.activateWallet} />
                  </Button>
                )}
              </WalletRegistrationOrUpdateButton>
            </>
          ) : (
            <FormattedMessage {...messages.emptyMessageRateViewer} />
          )}
        </div>
      </div>
    );
  }
  return (
    <div className={style['rate-list']}>
      <RateList onRateSelected={onRateSelected} provider={selectedProvider} selectedRate={selectedRate} />
    </div>
  );
};

MainContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  sellerProviderRates: PropTypes.arrayOf(RateBrowserProviderPropType).isRequired,
  validationErrors: PropTypes.array.isRequired,
  selectedRate: RateBrowserRatePropType,
  selectedProvider: RateBrowserSelectedProviderPropType,
  onRateSelected: PropTypes.func.isRequired,
};

export default MainContent;
